import { DashboardApiError } from '../../lib/apiClient';

export interface AppErrorContext {
  endpoint?: string;
  operation?: string;
  pathname?: string;
  retry?: () => void | Promise<void>;
}

export interface AppErrorItem {
  fingerprint: string;
  code: string;
  message: string;
  status: number;
  requestId?: string;
  endpoint: string;
  pathname: string;
  firstOccurredAt: string;
  lastOccurredAt: string;
  occurrences: number;
  retry?: () => void | Promise<void>;
}

const safeMessage = (error: Error, code: string): string =>
  error.message.replace(new RegExp(`^\\[${code}\\]\\s*`), '');

export function fingerprintError(
  item: Pick<AppErrorItem, 'code' | 'status' | 'endpoint' | 'message'>,
): string {
  return [item.code, item.status, item.endpoint, item.message].join('|');
}

export function normalizeAppError(
  error: unknown,
  context: AppErrorContext = {},
): AppErrorItem {
  const apiError = error instanceof DashboardApiError ? error : null;
  const nativeError = error instanceof Error ? error : new Error(String(error));
  const code = apiError?.code ?? 'network_error';
  const now = new Date().toISOString();
  const endpoint = (context.endpoint ?? apiError?.endpoint ?? 'ไม่ทราบ').split(
    '?',
  )[0];
  const item: AppErrorItem = {
    fingerprint: '',
    code,
    message: safeMessage(nativeError, code),
    status: apiError?.status ?? 0,
    requestId: apiError?.requestId,
    endpoint,
    pathname: context.pathname ?? window.location.pathname,
    firstOccurredAt: now,
    lastOccurredAt: now,
    occurrences: 1,
    retry: context.retry,
  };
  item.fingerprint = fingerprintError(item);
  return item;
}

export function toSupportText(item: AppErrorItem): string {
  return [
    'POS Dashboard Error',
    `ข้อความ: ${item.message}`,
    `Error code: ${item.code}`,
    `HTTP status: ${item.status || 'network'}`,
    `Request ID: ${item.requestId ?? 'ไม่มี'}`,
    `Endpoint: ${item.endpoint}`,
    `หน้า: ${item.pathname}`,
    `เวลา: ${item.lastOccurredAt}`,
    `จำนวนครั้ง: ${item.occurrences}`,
  ].join('\n');
}
